module.exports = __webpack_public_path__ + "img/day-office-travel-agency.3854acf2.jpg";